<template>
    <div class="placeholder">
        <div class="placeholder__heading">
            <d-tooltip placement="left" identifier="employees.claims" />
            Afsluttede reklamationer
        </div>
        <div class="placeholder">
            
            <vue-good-table
            :columns="columns"
            :rows="rows"
            :search-options="searchOptions"
            :pagination-options="paginationOptions"
            :sort-options="sortOptions"
            :styleClass="styleClass"
            v-if="!loading"
            >
                <div slot="emptystate">
                    Ingen data ...
                </div>
                <template slot="table-row" slot-scope="props">
                    <div class="coverage-cell" v-if="props.column.field == 'coverage_percent'">
                        {{ props.row.coverage_percent | rounded }} 
                        <div
                            v-if="props.row.coverage_percent !== null"
                            class="coverage-indicator"
                            :class="{'bad': props.row.coverage_percent < $store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': $options.filters.rounded(props.row.coverage_percent) >= $store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': $options.filters.rounded(props.row.coverage_percent) >= $store.state.config.companyMeta.settings.coverage_percent.high.value}"
                        />
                    </div>
                    <div v-else-if="props.column.field == 'case_number'" class="table-column__ordernumber" style="text-align:left;">
                        {{ props.row.case_number }}
                    </div>
                    <div v-else-if="props.column.field == 'description'" class="table-column__description" :title="props.row.description">
                        {{ props.row.description }}
                    </div>
                    <div v-else-if="props.column.field == 'customer.name'" class="table-column__customer" :title="props.row.customer.name">
                        <span v-if="props.row.customer">
                            {{ props.row.customer.name }}
                        </span>
                        <span v-else> - </span>
                    </div>
                    <div v-else-if="props.column.field == 'invoices_total'">
                        {{ props.row.invoices_total | currency}}
                    </div>
                    <div v-else-if="props.column.field == 'coverage'">
                        <!--{{ props.row.coverage | currency}}-->
                        {{ props.row.invoices_total - props.row.total_expenses | currency }}
                    </div>
                    <div class="coverage-cell" v-else-if="props.column.field == 'coverage_per_hour'">
                        {{ props.row.coverage_per_hour | currency }} 
                        <div
                            v-if="props.row.coverage_per_hour !== null"
                            class="coverage-indicator"
                            :class="{'bad': props.row.coverage_per_hour < $store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': $options.filters.rounded(props.row.coverage_per_hour) >= $store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': $options.filters.rounded(props.row.coverage_per_hour) >= $store.state.config.companyMeta.settings.coverage_per_hour.high.value}"
                        />
                    </div>
                    <div v-else-if="props.column.field == 'action'" class="g-table__action" @click="openExternalLink(props.row.external_id)">
                        <i class="fad fa-eye" />
                    </div>
                    <div v-else-if="props.column.field == 'start_date'">
                        {{ props.row.start_date | moment("DD. MMM YYYY") }}
                    </div>
                    <div v-else-if="props.column.field == 'minuba_external_id'">
                        <a :href="'https://app.minuba.dk/?op=casedetails&glist=' + props.row.minuba_external_id" target="_blank" class="minuba-link">
                            <i class="fas fa-eye"></i>
                        </a>
                    </div>
                    <div v-else :title="props.formattedRow[props.column.field]">
                        {{ props.formattedRow[props.column.field] }}
                    </div>
                </template>
            </vue-good-table> 

            <box-loading height="350" v-else />

        </div>
    </div>
</template>

<script>
import * as projectService from '@/services/projectService'

export default {
    data () {
        return {
            loading: true,
            columns: [
                { label: 'Ordre', field: 'case_number', type: 'number' },
                { label: 'Ansvarlig', field: 'responsible_employee.full_name', type: 'string' },
                { label: 'Opgave', field: 'description', type: 'string', width: '30%' },
                { label: 'Kunde', field: 'customer.name', type: 'string', width: '30%' },
                { label: 'Startdato', field: 'start_date', type: 'string', width: '10%' },
                { label: 'Omsætning', field: 'invoices_total', type: 'number' },
                { label: 'DB', field: 'coverage', width: '10%', type: 'number' },
                { label: 'DG', field: 'coverage_percent', width: '8%', type: 'number' },
                { label: 'DB/time', field: 'coverage_per_hour', width: '8%', type: 'number' }
            ],
            rows: [],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 10,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'responsible_employee.full_name',
                    type: 'asc'
                }
            },
            styleClass: 'vgt-table'
        }
    },
    created () {
        if (this.$auth.user().company.api_provider.slug === 'minuba') {
            this.columns.push({ label: 'Åbn', field: 'minuba_external_id' })
        }
        this.getData()
    },
    methods: {
        getData () {
            this.loading = true
            this.$emit('finishedLoading', null)
            let dateFrom = this.$store.getters.getStartDate
            let dateTo = this.$store.getters.getEndDate
            let params = {
                'filter[complaint]': true,
                'filter[status]': 'billed,posted',
                'filter[between]': dateFrom + ',' + dateTo,
                include: 'customer,type,responsibleEmployee'
            }
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params['filter[by_department_uuid]'] = this.$store.getters.getCurrentDepartment.uuid
            }
            projectService.claims(params, (response) => {
                this.rows = response.data
                this.$emit('finishedLoading', this.rows.length)
                this.loading = false
            }, (err) => {
                console.log(err)
                this.loading = false
            })
        }
    },
    computed: {
        globalParams () {
            let startDate = this.$store.getters.getStartDate
            let endDate = this.$store.getters.getEndDate
            let department = this.$store.getters.getCurrentDepartment.uuid
            return startDate + endDate + department
        }
    },
    watch: {
        globalParams: function () {
            this.getData()
        }
    }
}
</script>



// WEBPACK FOOTER //
// claims.vue?2e0fa1b5